@if(loading) {
  <div class="bg-black/50 flex justify-center items-center fixed inset-0 z-40">
    <app-loader [message]="messageLoader"></app-loader>
  </div>
}

<!-- Group form dialog -->
<p-dialog [header]="isEditing ? 'Editar Grupo' : 'Nuevo Grupo'" [(visible)]="showFormDialog" [modal]="true" [style]="{width: '400px'}">
  <form [formGroup]="formDeviceGroup" class="space-y-4 pt-2">
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Nombre del grupo</label>
      <input pInputText formControlName="groupName" class="w-full mt-1" placeholder="Ej: Flota Norte" />
    </div>
    @if(groupName.errors?.['duplicate']) {
      <small class="text-red-500">Este nombre ya existe</small>
    }
  </form>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showFormDialog=false"></button>
    <button pButton [label]="isEditing ? 'Actualizar' : 'Crear'" [disabled]="formDeviceGroup.invalid" (click)="addGroup()"></button>
  </ng-template>
</p-dialog>

<!-- Delete confirm dialog -->
<p-dialog header="Confirmar eliminación" [(visible)]="showDeleteConfirm" [modal]="true" [style]="{width: '400px'}">
  <p class="text-sm">¿Desea eliminar el grupo <b>{{ deleteTarget?.description }}</b>? Los dispositivos asignados serán desvinculados.</p>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showDeleteConfirm=false"></button>
    <button pButton label="Eliminar" class="p-button-danger" icon="pi pi-trash" (click)="showDeleteConfirm=false; deleteGroup(deleteTarget)"></button>
  </ng-template>
</p-dialog>

<div class="p-6">

  <!-- ===== GROUPS LIST VIEW ===== -->
  @if(!assign) {
    <div class="flex items-center justify-between mb-5">
      <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">Grupos de Dispositivos</h2>
      @if(isAdmin) {
        <button pButton label="Nuevo Grupo" icon="pi pi-plus" class="p-button-sm" (click)="openNewGroup()"></button>
      }
    </div>

    <p-table [value]="deviceGroups" styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="flex">
        <ng-template #header>
          <tr>
            <th>Grupo</th>
            <th class="text-center w-[100px]">Dispositivos</th>
            @if(isAdmin) {
              <th class="text-center w-[250px]">Acciones</th>
            }
          </tr>
        </ng-template>
        <ng-template #body let-group>
          <tr>
            <td>
              <div class="flex items-center gap-3">
                <div class="w-8 h-8 rounded-lg bg-vivid-royal-100 dark:bg-vivid-royal-800 flex items-center justify-center">
                  <i class="pi pi-folder text-vivid-royal-500 dark:text-vivid-royal-300"></i>
                </div>
                <span class="font-semibold text-vivid-royal-800 dark:text-white">{{ group.description }}</span>
              </div>
            </td>
            <td class="text-center">
              <span class="px-2 py-1 rounded-full text-xs font-semibold bg-vivid-royal-100 dark:bg-vivid-royal-800 text-vivid-royal-600 dark:text-vivid-royal-200">
                {{ group.deviceCount || 0 }}
              </span>
            </td>
            @if(isAdmin) {
              <td class="text-center">
                <div class="flex justify-center gap-1">
                  <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" pTooltip="Editar nombre" (click)="openEditGroup(group)"></button>
                  <button pButton icon="pi pi-link" class="p-button-rounded p-button-text p-button-sm" pTooltip="Asignar dispositivos" (click)="openAssignment(group)"></button>
                  <button pButton icon="pi pi-sliders-h" class="p-button-rounded p-button-text p-button-sm" pTooltip="Parámetros de carga" (click)="openBulkParams(group)"></button>
                  <button pButton icon="pi pi-clock" class="p-button-rounded p-button-text p-button-sm" pTooltip="Horarios de carga" (click)="openBulkSchedule(group)"></button>
                  <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text p-button-sm" pTooltip="Eliminar grupo" (click)="confirmDelete(group)"></button>
                </div>
              </td>
            }
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="isAdmin ? 3 : 2" class="text-center py-8 text-vivid-royal-400">
              <i class="pi pi-folder-open text-4xl mb-3 block"></i>
              <p>No hay grupos creados</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
  }

  <!-- ===== ASSIGNMENT VIEW ===== -->
  @if(assign) {
    <div class="space-y-4">
      <!-- Header -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <button pButton icon="pi pi-arrow-left" class="p-button-text p-button-sm" (click)="backToGroups()"></button>
          <div>
            <p class="text-xs text-vivid-royal-400 uppercase tracking-wide">Asignar dispositivos a</p>
            <h2 class="text-lg font-bold text-mustard-700 dark:text-mustard-400">{{ nameGroup }}</h2>
          </div>
        </div>
        @if(dataResult.length > 0) {
          <div class="flex gap-2">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-sm p-button-outlined" (click)="cancelAssignment()"></button>
            <button pButton label="Guardar cambios" icon="pi pi-check" class="p-button-sm" (click)="saveAssignment()"></button>
          </div>
        }
      </div>

      <!-- Search + select all -->
      <div class="flex flex-wrap items-center justify-between gap-3">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input pInputText type="text" placeholder="Buscar dispositivo..." (keyup)="searchByText($event)" class="w-72" />
        </p-iconfield>
        @if(devicesGroup.length > 0) {
          <button pButton [label]="isChecked ? 'Deseleccionar todos' : 'Seleccionar todos'" class="p-button-sm p-button-text" (click)="selectAll()"></button>
        }
      </div>

      <!-- Devices table -->
      @if(devicesGroup.length === 0) {
        <div class="text-center py-12 text-vivid-royal-400">No existen dispositivos</div>
      } @else {
        <p-table [value]="devicesGroup" [paginator]="devicesGroup.length > 20" [rows]="20"
          styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="450px">
          <ng-template #header>
            <tr>
              <th class="w-[60px]"></th>
              <th>Número</th>
              <th>Nombre</th>
              <th>Descripción</th>
            </tr>
          </ng-template>
          <ng-template #body let-item>
            <tr class="cursor-pointer" (click)="select(item)" [ngClass]="{'bg-vivid-royal-50 dark:bg-vivid-royal-900': item.type === 1 || item.type === 2}">
              <td class="text-center">
                @switch(item.type) {
                  @case(0) { <i class="pi pi-circle text-gray-300 text-lg"></i> }
                  @case(1) { <i class="pi pi-check-circle text-green-500 text-lg"></i> }
                  @case(2) { <i class="pi pi-check-circle text-mustard-700 dark:text-mustard-400 text-lg"></i> }
                  @case(4) { <i class="pi pi-times-circle text-red-400 text-lg"></i> }
                }
              </td>
              <td class="font-mono font-semibold">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
            </tr>
          </ng-template>
        </p-table>
      }

      <!-- Legend -->
      <div class="flex gap-6 text-xs text-vivid-royal-400 pt-2">
        <span><i class="pi pi-check-circle text-green-500 mr-1"></i> Asignado</span>
        <span><i class="pi pi-check-circle text-mustard-700 dark:text-mustard-400 mr-1"></i> Por asignar</span>
        <span><i class="pi pi-times-circle text-red-400 mr-1"></i> Por desasignar</span>
        <span><i class="pi pi-circle text-gray-300 mr-1"></i> Disponible</span>
      </div>
    </div>
  }

  <!-- Bulk Params Dialog -->
  <p-dialog [header]="'Parámetros — ' + paramsGroup?.description" [(visible)]="showParamsDialog" [modal]="true" [style]="{width: '520px'}">
    <form [formGroup]="formParams" class="space-y-4 pt-2">
      <div class="grid grid-cols-2 gap-1 rounded-xl bg-dark-khaki-100 dark:bg-vivid-royal-900 p-1 max-w-xs">
        <button pButton type="button" label="Importe" icon="pi pi-dollar" (click)="paramsLoadType=false"
          [class]="!paramsLoadType ? 'p-button-sm w-full' : 'p-button-sm p-button-text w-full'"></button>
        <button pButton type="button" label="Litros" icon="pi pi-box" (click)="paramsLoadType=true"
          [class]="paramsLoadType ? 'p-button-sm w-full' : 'p-button-sm p-button-text w-full'"></button>
      </div>

      @if(paramsLoadType) {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite diario (Litros)</label>
            <input pInputText formControlName="dailyLiters" mask="9999999" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite semanal (Litros)</label>
            <input pInputText formControlName="weeklyLiters" mask="9999999" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite mensual (Litros)</label>
            <input pInputText formControlName="monthlyLiters" mask="9999999" class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Máx. cargas diarias</label>
            <input pInputText formControlName="maxLoads" mask="99" class="w-full mt-1" />
          </div>
        </div>
      } @else {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite diario ($)</label>
            <input pInputText formControlName="dailyAmount" mask="separator.2" decimalMarker="." thousandSeparator="," class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite semanal ($)</label>
            <input pInputText formControlName="weeklyAmount" mask="separator.2" decimalMarker="." thousandSeparator="," class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Límite mensual ($)</label>
            <input pInputText formControlName="monthlyAmount" mask="separator.2" decimalMarker="." thousandSeparator="," class="w-full mt-1" />
          </div>
          <div>
            <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Máx. cargas diarias</label>
            <input pInputText formControlName="maxLoads" mask="99" class="w-full mt-1" />
          </div>
        </div>
      }

      <div class="text-sm text-yellow-700 bg-yellow-50 border border-yellow-300 rounded-lg px-3 py-2">
        <i class="pi pi-info-circle mr-1"></i> Se aplicará a todos los dispositivos del grupo.
      </div>
    </form>
    <ng-template #footer>
      <button pButton label="Cancelar" class="p-button-text" (click)="showParamsDialog=false" [disabled]="savingParams"></button>
      <button pButton [label]="savingParams ? 'Aplicando...' : 'Aplicar a grupo'"
        [icon]="savingParams ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="formParams.invalid || savingParams" (click)="saveBulkParams()"></button>
    </ng-template>
  </p-dialog>

  <!-- Bulk Schedule Dialog -->
  <p-dialog [header]="'Horarios — ' + scheduleGroup?.description" [(visible)]="showScheduleDialog" [modal]="true" [style]="{width: '700px'}">
    <div class="space-y-4 pt-2">
      <div class="flex items-center gap-3">
        <label class="text-sm font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Restringir horarios</label>
        <p-selectbutton [options]="[{label:'Sí', value:true},{label:'No', value:false}]" [(ngModel)]="scheduleEnabled"
          optionLabel="label" optionValue="value" [allowEmpty]="false" />
      </div>

      @if(scheduleEnabled) {
        <div class="overflow-x-auto">
          <table class="w-full text-xs">
            <thead>
              <tr>
                <th class="text-left py-1 px-2">Día</th>
                @for(h of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]; track h) {
                  <th class="py-1 px-0.5 text-center text-vivid-royal-400">{{ h }}</th>
                }
                <th class="px-2"></th>
              </tr>
            </thead>
            <tbody>
              @for(day of days; track day.key) {
                <tr>
                  <td class="font-semibold py-1 px-2 text-vivid-royal-700 dark:text-vivid-royal-200">{{ day.label }}</td>
                  @for(h of [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]; track h) {
                    <td class="text-center px-0.5">
                      <button type="button" class="w-5 h-5 rounded-sm text-[10px] transition-colors"
                        [ngClass]="day.hours[h] ? 'bg-green-500 text-white' : 'bg-red-100 text-red-400 dark:bg-red-900 dark:text-red-300'"
                        (click)="toggleHour(day, h)">
                        {{ day.hours[h] ? '✓' : '✕' }}
                      </button>
                    </td>
                  }
                  <td class="px-2">
                    <button pButton type="button" icon="pi pi-replay" class="p-button-text p-button-sm p-button-rounded" (click)="toggleDay(day)"></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <div class="text-sm text-vivid-royal-400 py-4 text-center">Sin restricción de horarios — los dispositivos podrán cargar a cualquier hora.</div>
      }

      <div class="text-sm text-yellow-700 bg-yellow-50 border border-yellow-300 rounded-lg px-3 py-2">
        <i class="pi pi-info-circle mr-1"></i> Se aplicará a todos los dispositivos del grupo.
      </div>
    </div>
    <ng-template #footer>
      <button pButton label="Cancelar" class="p-button-text" (click)="showScheduleDialog=false" [disabled]="savingSchedule"></button>
      <button pButton [label]="savingSchedule ? 'Aplicando...' : 'Aplicar a grupo'"
        [icon]="savingSchedule ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        [disabled]="savingSchedule" (click)="saveBulkSchedule()"></button>
    </ng-template>
  </p-dialog>
</div>
